export class SubscriberReport {
  async report(attributes) {
    const response = await fetch("/api/v3/growth_stats", {
      credentials: "include",
      method: "POST",
      body: JSON.stringify({ report: attributes }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content
      }
    })
    return await response.json()
  }
}
